/**
 *  @author:        Cloud for Good
 *  @description:   Applies custom Advancement logic to the SFRA js/components/consentTracking.js client-side logic.
 *                  Overriding from base to remove callouts to the controller routes that collect content asset and update html for the modal
 *                  and add subdomain specific cookies.
 *
 *  History
 *  <Date>        <Author Name>       <Reference #>       <Change Description>
 *  2022-09-30    Cloud for Good       N/A                Initial creation
 *  2024-08-19    Jassin Yacks         CFG-486            Updated the code to use ensuring that the cookie content is now placed at the top of the <body> tag rather than at the end.
*/
'use strict';

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}

/**
 * Renders a modal window that will track the users consenting to accepting site tracking policy
 */
function showConsentModal() {

    var urlContent = $('.tracking-consent').data('url');
    var urlAccept = $('.tracking-consent').data('accept');
    var urlReject = $('.tracking-consent').data('reject');
    var textYes = $('.tracking-consent').data('accepttext');
    var textNo = $('.tracking-consent').data('rejecttext');

    // if cookie is already set, don't show modal
    if (getCookie('consentTracking')) {
        var consentURL = getCookie('consentTracking') === 'true' ? urlAccept : urlReject;
        // make sure session cache value matches cookie value
        $.ajax({
            url: consentURL,
            type: 'get',
            dataType: 'json',
            success: function () {
                $('#consent-tracking').remove();
            },
            error: function () {
                $('#consent-tracking').remove();
            }
        });
        return;
    }

    var htmlString = '<!-- Modal -->'
        + '<div id="consent-tracking" role="dialog" style="display: block;">'
        + '<div class="content row py-2">'
        + '<div class="consent-body-wrapper text-center mb-1 mx-5 mx-sm-auto">'
        + '<div class="consent-body">' + urlContent + '</div>'
        + '<div class="button-wrapper px-2">'
        + '<button class="affirm slds-button slds-button_brand slds-m-right_small" data-url="' + urlAccept + '">'
        + textYes
        + '</button>'
        + '<button class="decline slds-button slds-button_outline-brand" data-url="' + urlReject + '">'
        + textNo
        + '</button>'
        + '</div>'
        + '</div>'
        + '</div>'
        + '</div>';

    $('body').prepend(htmlString);

    $('#consent-tracking .button-wrapper button').click(function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function () {
                $('#consent-tracking').remove();
                $.spinner().stop();
            },
            error: function () {
                $('#consent-tracking').remove();
                $.spinner().stop();
            }
        });
    });
}

module.exports = function () {
    if ($('.consented').length === 0 && $('.tracking-consent').hasClass('api-true')) {
        showConsentModal();
    }

    if ($('.tracking-consent').hasClass('api-true')) {
        $('.tracking-consent').click(function () {
            showConsentModal();
        });
    }

    // if consent is given for consent tracking, set cookie to prevent pop-up after logging in
    $('body').on('click', '#consent-tracking .affirm', function (e) {

        //to ensure cookies get set based on the site, only set the domain for non-prod & Development sites
        if((document.location.host).includes('.northeastern.edu')){
            document.cookie = 'consentTracking=true; path=/ ;samesite=lax; domain=northeastern.edu';
        }else{
            document.cookie = 'consentTracking=true; path=/ ;samesite=lax';
        }

    });

    // if consent is denied for consent tracking, set cookie to prevent pop-up after logging in
    $('body').on('click', '#consent-tracking .decline', function (e) {

        //to ensure cookies get set based on the site, only set the domain for non-prod & Development sites
        if((document.location.host).includes('.northeastern.edu')){
            document.cookie = 'consentTracking=false; path=/ ;samesite=lax; domain=northeastern.edu';
        }else{
            document.cookie = 'consentTracking=false; path=/ ;samesite=lax';
        }

    });
};
